/*=========================================================================================
  File Name: moduleDataList.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import state from "./moduleZonificationState.js";
import mutations from "./moduleZonificationMutations.js";
import actions from "./moduleZonificationActions.js";
import getters from "./moduleZonificationGetters.js";

export default {
	isRegistered: false,
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
